export const SET_LOADING = 'SET_LOADING';
export const SET_NEW_TRUSTED = 'SET_NEW_TRUSTED';
export const RESET_PARAMS = 'RESET_PARAMS';
export const ADD_FILE_PATH_LOADED = 'ADD_FILE_PATH_LOADED';

export function setLoading(value) {
  return {
    type: SET_LOADING,
    value,
  };
}

export function setIsNewTrusted(value) {
  return {
    type: SET_NEW_TRUSTED,
    value,
  };
}

export function addFilePathLoaded(value) {
  return {
    type: ADD_FILE_PATH_LOADED,
    value,
  };
}

export function resetParams() {
  return {
    type: RESET_PARAMS,
  };
}
